/**
 * DEC-1145 (FEEDBACK-1): the client's build identity.
 *
 * Before this the frontend had no version at all — `client/package.json` says
 * 1.0.0 while production runs v31.x, so nothing a user reported could be tied
 * to the bundle they were actually running. Every bug report from now on
 * carries this, which is the difference between "the dashboard was broken"
 * and "the dashboard was broken on v31.2.0".
 *
 * Injected at BUILD time by scripts/deploy.sh (`git describe --tags --always
 * --dirty`). Create React App only forwards env vars prefixed REACT_APP_ and
 * inlines them during the build, so this value is frozen into the bundle — it
 * cannot drift from the code it shipped with, which is exactly the property
 * that makes it trustworthy in a bug report.
 *
 * Falls back to 'dev' for local `npm start`, where no stamp is set. Deliberately
 * a distinct value from the deploy script's own 'unknown' fallback: 'dev' means
 * "a developer's machine", 'unknown' means "a real build whose git context was
 * unavailable" — different problems, and conflating them would hide the second.
 */

export const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';

/** True when running an un-stamped local build (not a deployed artifact). */
export const IS_DEV_BUILD = APP_VERSION === 'dev';

export default APP_VERSION;
